<template>
  <div>
    <MyBreadcrumb
      :breadcrumb-list="[
        {text:'应用详情',to:{path:'/app/appDetail/index',query:{productCode:$route.query.productCode}}},
        {text:'应用订购',to:''}
      ]"
    ></MyBreadcrumb>

    <div class="page-content">
      <div class="steps-box">
        <Steps :current="0">
          <Step
            v-if="$route.query.type==='renew'"
            title="提交续费订单"
          ></Step>
          <Step
            v-else
            title="提交订单"
          ></Step>
          <Step
            title="去支付"
          ></Step>
          <Step
            title="支付完成"
          ></Step>
        </Steps>
      </div>
      <div class="form-box">
        <Form
          ref="form"
          :model="form.params"
        >
          <div
            class="table-section"
          >
            <div class="section-header">
              <span class="section-name">订购明细</span>
              <span class="section-tip">主体信息：{{ $store.state.user.userInfo.corpName }}</span>
              <span class="section-tip">系统账号：{{ $route.query.accountNo }}</span>
            </div>
            <Table
              :columns="table.columns"
              :data="table.data"
            >
            </Table>
          </div>
          <div class="coupons-box">
            <span class="coupons-text">优惠码</span>
            <Input
              v-model="coupons.couponCode"
              class="input-coupons"
              placeholder="请输入优惠码"
              clearable
              @input="coupons.on.input"
              @on-clear="coupons.on.clear"
            ></Input>
            <span
              class="coupons-query"
              type="text"
              @click="coupons.on.couponsQuery"
            >
              查询
            </span>
            <div
              v-if="coupons.errorMessage"
              class="error-coupons"
            >
              {{ coupons.errorMessage || '无效优惠码' }}
            </div>
          </div>
          <div class="clearfix">
            <div class="form-bottom-right">
              <div class="total-section">
                <div
                  v-if="coupons.couponsPrice"
                  class="couponsPrice"
                >
                  优惠金额：-￥{{ coupons.couponsPrice|moneyFix }}
                </div>
                <div class="total-content">
                  <span
                    v-if="$route.query.type==='renew'"
                    class="total-text"
                  >续费金额：</span>
                  <span
                    v-else
                    class="total-text"
                  >支付金额：</span>
                  <span class="total-price">￥{{ totalPrice|moneyFix }}</span>
                </div>
              </div>
              <FormItem
                prop="policy"
                :rules="form.rules.policy"
              >
                <Checkbox v-model="form.params.policy">
                  我已阅读并同意
                  <a
                    :href="skuInfo.buyProtocol"
                    download="服务订购协议"
                    target="_blank"
                  > 《服务订购协议》</a>
                </Checkbox>
              </FormItem>
              <div>
                <Button
                  type="primary"
                  :loading="form.loading"
                  @click="form.on.submit"
                >
                  去支付
                </Button>
              </div>
            </div>
          </div>
        </Form>
      </div>
      <!--是否已经存在有待付款的订单弹框提示  -->
      <Modal
        v-model="orderModal.visiable"
        :footer-hide="true"
        :closable="false"
        :width="300"
      >
        <div style="padding: 10px 20px;">
          {{ orderModal.message }}
        </div>
        <div style="text-align: center; margin-top: 10px;">
          <div v-if="orderModal.checkRes.hasTransferPay">
            <Button
              type="primary"
              @click="orderModal.on.goOrderDetail"
            >
              前往取消订单
            </Button>
          </div>
          <div v-else-if="orderModal.checkRes.hasWaitPay">
            <Button
              type="primary"
              style="margin-right: 30px;"
              @click="orderModal.on.reCreateOrder"
            >
              重新订购
            </Button>
            <Button @click="orderModal.on.goOrderDetail">
              继续完成支付
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  </div>
</template>
<script>
import {Steps,Step} from 'view-design';
export default {
  components: {
    Steps,
    Step,
  },
  data(){
    return {
      // 规格信息
      skuInfo: {
        skuItemList: [],
      },
      selectSkuItem: {},
      detail: {
        versionList: [
          {},
        ],
      },
      // form表单
      form: {
        loading: false,
        params: {
          productCode: this.$route.query.productCode,
        },
        rules: {
          policy: [
            {
              required: true,
              validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error('请勾选同意协议！'));
                } else {
                  callback();
                }
              },
              trigger: 'change',
            },
          ],
        },
        on: {
          createOrder: async()=>{
            const {
              productCode,
            } = this.$route.query;

            let {productSkuId} = this.skuInfo;
            if (this.selectSkuItem.skuId){
              productSkuId = this.selectSkuItem.skuId;
            }
            const {couponCode} = this.coupons;
            const {corpCode,corpName} = this.$store.state.user.userInfo;
            // productType是3 接口应用 才有 unifiedEntityId, pid,
            const {
              accountNo,
              unifiedEntityId,
              pid,
              orderType, // 1购买 3续费
              buyRecordId,
              appProductId,// 组合产品需要
            } = this.$route.query;
            // const url = '/paycenter-charge/api/facade/order/create';
            const url = '/paycenter-charge/api/worktable/order/create';
            const params = {
              corpCode,
              corpName,
              accountNo,
              productCode,
              exchange: false,
              productSkuId,
              shopNum: 0,
              buyRecordId,
              couponCode,
              orderType: orderType||1,
              unifiedEntityId,
              pid,
              appProductId,
            };
            this.form.loading = true;
            const res = await this.$http.post(url,params);
            setTimeout(()=>{this.form.loading = false;},300);

            if (res.success) {
              this.pay({
                orderNo: res.data.orderNo,
                accountNo,
                productCode,
              });
              // this.$router.push({
              //   path: '/pay/index',
              //   query: {
              //     orderNo: res.data.orderNo,
              //   },
              // });
            } else {
              this.$Message.warning(res.message||'创建订单失败');
            }
          },
          submit: ()=>{
            this.$refs.form.validate(async (valid) => {
              if (valid) {
                // 去支付
                // 如果相同的saas产品或相同的应用，已经存在有待付款的订单 在<去支付> 时
                // 提示 “你有服务订单尚未完成支付，请前往支付或重新订购”
                // 前置条件：同一主体、相同产品或应用下
                const checkRes = await this.orderModal.on.check();
                if (checkRes){
                  this.form.on.createOrder();
                }
              }
            });
          },
        },
      },
      orderModal: {
        visiable: false,
        checkRes: {},
        message: '',
        on: {
          // 相同的saas产品或相同的应用，是否已经存在有待付款的订单
          check: async()=>{
            const {
              // corpCode,
              // corpName,
              productCode,
            } = this.$route.query;
            const {corpCode} = this.$store.state.user.userInfo;
            // 下单校验
            const url = '/paycenter-charge/api/worktable/order/create/check';
            const params = {
              productCode,corpCode,
            };

            if (this.$route?.query?.accountNo){
              params.accountNo = this.$route?.query?.accountNo;
            }

            const res = await this.$http.get(url,params);
            if (res.success){
              this.orderModal.checkRes = res.data;
              const {hasWaitPay,hasTransferPay} = res.data;
              if (hasTransferPay){
                this.orderModal.message = '你有转账汇款服务订单尚未审核，请先取消订单';
                this.orderModal.visiable = true;
                return false;
              }
              if (hasWaitPay){
                this.orderModal.message = '你有服务订单尚未完成支付，请前往支付或重新订购';
                this.orderModal.visiable = true;
                return false;
              }
              return true;
            } else {
              this.$Message.warning(res.message||'接口请求失败');
            }
          },
          goOrderDetail: ()=>{
            this.$router.push({
              path: '/app/orderRecord/Detail',
              query: {
                orderNo: this.orderModal.checkRes.orderNo,
              },
            });
          },
          reCreateOrder: ()=>{
            this.form.on.createOrder();
          },
        },
      },
      // 优惠码
      coupons: {
        collapse: '',
        couponCode: '',
        couponsPrice: '',
        errorMessage: '',
        loading: false,
        on: {
          couponsQuery: ()=>{
            const {couponCode} = this.coupons;
            if (!couponCode){
              this.$Message.warning('请先输入优惠码');
              return;
            }
            // const url = '/paycenter-charge/api/facade/order/coupon';
            const url = '/paycenter-charge/api/worktable/order/coupon';
            const params = {
              couponCode,
            };
            this.coupons.loading = true;
            this.$http.post(url,params).then(res => {
              setTimeout(()=>{this.coupons.loading = false;},300);

              if (res.success) {
                this.coupons.couponsPrice = res.data;
                this.coupons.errorMessage = '';
              } else {
                this.coupons.couponsPrice = '';
                this.coupons.errorMessage = res.message || '无效优惠码';
              }
            });
          },
          clear: ()=>{
            this.coupons.couponsPrice = '';
            this.coupons.errorMessage = '';
          },
          input: (value)=>{
            if (value===''){
              this.coupons.couponsPrice = '';
              this.coupons.errorMessage = '';
            }
          },
        },
      },
      // 表格
      table: {
        columns: [
          {
            title: '订购服务',
            // key: 'ser',
            width: 260,
            render: (h)=>{
              const {saleName,productImage} = this.detail;
              const html = [];
              const img = h('img',{
                style: {
                  width: '66px',
                  height: '44px',
                  verticalAlign: 'middle',
                  marginRight: '5px',
                  flexShrink: 0,
                },
                attrs: {
                  src: productImage,
                },
              });
              html.push(img);
              const span = h('span',saleName);
              html.push(span);
              return h('div',{style: 'display:flex;align-items: center;padding:20px 0'},html);
            },
          },
          {
            title: '套餐',
            key: 'title',
            // render: (h,params)=>{
            //   const {saleName} = this.detail;
            //   const html = [];
            //   const span = h('span',saleName);
            //   html.push(span);
            //   return html;
            // },
          },
          {
            title: '服务周期',
            key: '服务周期',
          },
          {
            title: '价格',
            key: 'salePrice',
            render: (h,params)=>{
              const {salePrice} = params.row;
              const html = [];
              const span = h('span',`￥${this.$options.filters.moneyFix(salePrice)}`);
              html.push(span);
              return html;
            },
          },
        ],
        data: [
          // {
          //   version: '营销工具特惠版本限时抢购',
          //   type: '试用版',
          //   period: '7天',
          //   price: '￥9600.00',
          // },
        ],
      },
    };
  },
  computed: {
    totalPrice(){
      // 总价格
      let totalPrice = '';
      // 选中的规格价格
      let {salePrice} = this.skuInfo;
      // 如果设置了规格
      if (this.selectSkuItem.skuId){
        salePrice = this.selectSkuItem.salePrice;
      }
      // let {salePrice} = this.selectSkuItem;
      // 优惠价格
      const {couponsPrice} = this.coupons;

      totalPrice =Number(salePrice||0)-Number(couponsPrice||0);
      if (totalPrice<=0){
        totalPrice=0;
      }
      return totalPrice;
    },
  },
  mounted(){
    const {
      from,
    } = this.$route.query;
    if (from==='distributionChannels'){
      sessionStorage.setItem('pageFrom','distributionChannels');
    }
  },
  created(){
    // 获取详情
    this.getDetail();
    // 获取规格
    this.getSkuInfo();

    // 如果是续费或升级
    const {orderNo} = this.$route.query;
    if (orderNo){
      this.getOrderedSku(orderNo);
    }
  },
  methods: {
    // 获取详情
    getDetail() {
      const {corpCode} = this.$store.state.user.userInfo;
      const url = '/paycenter-charge/api/facade/product/view';
      const params = {
        productCode: this.$route.query.productCode,
        corpCode,
      };
      this.$http.get(url,params).then(res => {
        if (res.success) {
          this.detail = res.data;
        } else {
          this.$Message.warning(res.message || '获取详情失败');
        }
      });
    },
    // 获取规格
    getSkuInfo() {
      // const url = '/paycenter-charge/api/facade/product/skuInfo';
      const url = '/paycenter-charge/api/worktable/skuInfo';
      const params = {
        productCode: this.$route.query.productCode,
      };
      this.$http.get(url,params).then(res => {
        if (res.success) {
          this.skuInfo = {
            ...res.data,
          };
          // 查询订购明细
          const {skuId} = this.$route.query;
          const {skuItemList} = this.skuInfo;
          if (skuItemList && skuItemList.length){
            const skuIdItem = this.skuInfo.skuItemList.find(ele=>ele.skuId==skuId);
            if (skuIdItem){
              let {propertyValues} = skuIdItem;
              propertyValues = JSON.parse(propertyValues);
              this.selectSkuItem = {
                ...skuIdItem,
                propertyValues,
              };
              this.table.data = [
                {
                  ...skuIdItem,
                  ...propertyValues,
                },
              ];
            }
          }
        } else {
          this.$Message.warning(res.message || '获取详情失败');
        }
      });
    },
    // 获取已经订购的规格信息
    getOrderedSku(orderNo) {
      const url = '/paycenter-charge/api/worktable/ordered/version';
      const params = {
        orderNo,
      };
      this.$http.get(url,params).then(res => {
        if (res.success) {
          this.orderedSku = res.data;
        } else {
          this.$Message.warning(res.message || '获取已经订购的规格信息失败');
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.page-content {
  background-color: #fff;
}
.steps-box {
  padding-top: 30px;
  width: 600px;
  margin: 0  auto 80px;
}
.form-box {
  padding: 20px 30px;
}
.table-section {
  // width: 700px;
  box-sizing: border-box;
  margin: 0 auto 20px;
  .section-header {
    margin-bottom: 20px;
  }
  .section-name {
    font-weight: bold;
    font-size: 18px;
    margin-right: 10px;
  }
  .section-tip {
    color: #999;
    font-size: 13px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 20px;
  }
}
.coupons-box {
  /deep/ .ivu-collapse-header {
    width: 100px;
  }
  .input-coupons {
    box-sizing: border-box;
    width: 200px;
    // outline: 0;
    // border: 1px solid #e0e0e0;
    // border-radius: 5px;
    // padding: 0 20px;
    margin-right: 10px;
    // /deep/ .ivu-input {
    //   border: 0;
    //   outline: 0;
    //   &:focus {
    //     box-shadow: 0 0;
    //   }
    // }
  }
  .coupons-text {
    font-weight: bold;
    margin-right: 10px;
  }
  .coupons-query {
    border: 1px solid #e0e0e0;
    outline: 0;
    text-align: center;
    padding: 6px 20px;
    border-radius: 5px;
  }
  .error-coupons {
    color: #ed4014;
    font-size: 12px;
    padding-top: 5px;
  }
}
.total-section {
  .couponsPrice {
    color: #f00;
  }
  .total-content {
    padding: 10px 0;
  }
  .total-text {
    font-weight: bold;
    color: #333;
  }
  .total-price {
    font-weight: bold;
    color: #f00;
    margin-right: 10px;
    font-size: 16px;
  }
  .total-detail {
    font-size: 12px;
    color: #409eff;
    cursor: pointer;
  }
}
.form-bottom-right {
  float: right;
}

</style>
